import React, { Component, Fragment } from 'react';
import { Icon, message } from 'antd';
import i18n from "../../../../../../constants/initLng";
import * as HMS from '../../../../common/component/Index';
import * as Func from '../../../../../../helpers/functions';
import UploadImage from '../../../../common/component/UploadImage';
import DEFINE from "../../../../../../constants/Define";
import { cloneDeep } from 'lodash';

export default class Media extends Component {

    constructor(props) {
        super(props);
        this.state = {}
    }

    getThumbSources(thumbs) {
        return thumbs.map(t => `${DEFINE.GENERAL.CDN_IMG_DEFAULT}${t.url}`)
    }

    onChangeImagesOrder = (e) => {
        const media = cloneDeep(this.props.roomType.media || []);
        const newMedia = media.map(x=>{
            return {
                ...x,
                order: e.findIndex(y=>y.endsWith(x.url))
            };
        }).sort((a, b) => a.order - b.order);
        this.props.onChange({name: 'media', value: newMedia});
    }

    render() {
        const { isUploading, roomType, loading } = this.props;
        return (
            <Fragment>
                <h3>{i18n.t(`item.roomType.media`)}</h3>
                <HMS.FormWrapperInputComponent>
                    <UploadImage
                        multiple={true}
                        loading={isUploading}
                        thumbnailSize={120}
                        buttonSize={120}
                        uploadText={i18n.t('item.tour.uploadFile')}
                        loadingText={i18n.t('item.tour.uploading')}
                        onChange={this.props.uploadFileMultiple}
                        onRemoveThumbnail={(src, index) => this.props.removeImage(src)}
                        thumbnails={this.getThumbSources(roomType.media || [])}
                        allowChangeOrder={true}
                        onChangeOrder={this.onChangeImagesOrder}/>
                </HMS.FormWrapperInputComponent>
            </Fragment>
        );
    }
}

